import { render, staticRenderFns } from "./ForgotPasswordFaq.vue?vue&type=template&id=5d986ea2&scoped=true&"
import script from "./ForgotPasswordFaq.vue?vue&type=script&lang=ts&"
export * from "./ForgotPasswordFaq.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d986ea2",
  null
  
)

export default component.exports